<script setup lang="ts">
import { LegacyRma, LegacyStateTransition } from '@hantera/portal-app';


const props = defineProps<{
  rma: LegacyRma
  transition: LegacyStateTransition
}>();

// TODO: Add localization

</script>

<template>
  <div class="timeline-rma-state-change">
    RMA <span class="timeline-rma-state-change__number">{{ rma.rmaNumber }}</span> state changed
    from
    <span
      class="timeline-rma-state-change__state"
      :style="`background-color: var(--state-colors__rma-${transition.fromState?.toLowerCase()})`"
    >
      {{ transition.fromState }}</span> to <span
      class="timeline-rma-state-change__state"
      :style="`background-color: var(--state-colors__rma-${transition.toState?.toLowerCase()})`"
    >{{ transition.toState }}</span>
  </div>
</template>

<style>
.timeline-rma-state-change {
  max-width: 800px;
  margin-top: -4.5px;
}

.timeline-rma-state-change__color-indicator {
  display: inline-block;
  width: 5px;
  border-radius: 5px;
  height: 20px;
  vertical-align: sub;
  margin: 0 2px;
}

.timeline-rma-state-change__timestamp,
.timeline-rma-state-change__number {
  font-weight: 600;
}

.timeline-rma-state-change__state {
  font-weight: 600;
  color: white;
  display: inline-block;
  padding: 4px 4px 3px 4px;
  border-radius: 4px;
}
</style>